import {
  PhoneNumberField as DSPhoneNumberField,
  type PhoneNumberFieldProps,
} from '@hostfully/ui-components';
import { useTranslation } from 'react-i18next';

const PhoneNumberField = (props: PhoneNumberFieldProps) => {
  const { t } = useTranslation();
  return (
    <DSPhoneNumberField
      {...props}
      getCountryName={(code: string) => t('countries.' + code.toLowerCase())}
    />
  );
};

export type { PhoneNumberFieldProps };
export default PhoneNumberField;
